import React, {Component} from 'react';
import document from 'react-dom';
import * as El from './components/formEl';
import Form from './pages/emailForm';


class App extends Component {

render() {
    return (
      <div>
        <link href="https://d1s0utqm8q1db1.cloudfront.net/fonts/style.css" rel="stylesheet"></link>
      <Form></Form>
      </div>
    );
  }
}

export default App;
